import t from 'babel-plugin-yate/macro';
import React, {useCallback, useState, useMemo} from 'react';

import OfferGroupRefinanceItem from './OfferGroupRefinanceItem';

export default function OfferGroupRefinance(props) {
  const {uuid, items, requestType, handleSelectOffer} = props;
  const [currentItem, setCurrentItem] = useState(items[0]);

  const {is_credit_card: isConsumerFinanceWithCard, paired_offer_id} =
    currentItem;

  const isConsumerFinance = requestType === 4;
  const isPersonalNeeds = requestType === 5;
  const isCreditCard = requestType === 6;

  const heading = useMemo(() => {
    if (isCreditCard || isConsumerFinanceWithCard) {
      return t`Creditul de tip card de credit a fost aprobat`;
    }

    if (isPersonalNeeds) {
      return t`Creditul de nevoi personale a fost aprobat`;
    }

    if (isConsumerFinance) {
      return t`Creditul de bunuri de consum a fost aprobat`;
    }
  }, [
    isCreditCard,
    isPersonalNeeds,
    isConsumerFinance,
    isConsumerFinanceWithCard,
  ]);

  const handleSelectInsurance = useCallback(() => {
    setCurrentItem(items.find(item => item.id === paired_offer_id));
  }, [items, paired_offer_id]);

  if (!currentItem?.paired_offer_responses) {
    return null;
  }

  return (
    <div className="flex pl-10 pb-10 relative flex-grow md:flex-grow-0">
      <div className="flex flex-grow flex-col rounded shadow-md bg-white overflow-hidden p-4">
        <OfferGroupRefinanceItem
          heading={heading}
          item={currentItem}
          isCreditCard={isCreditCard}
          isConsumerFinanceWithCard={isConsumerFinanceWithCard}
          onChangeInsurance={handleSelectInsurance}
          onSelect={handleSelectOffer}
          hasOneItem={items.length === 1}
          uuid={uuid}
        />
      </div>
    </div>
  );
}
